import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { SystemStatusPage } from "@/features/system-status/pages/system-status-page";

export const Route = createFileRoute("/_authenticated/admin/system-status")({
	head: () => pageTitle("System Status"),
	component: SystemStatusPage,
});
